import { 
    setTanks, 
    setAreas,  
    setTanksOperations, 
    setTanksStateOperations, 
    addTank, 
    addArea, 
    addTankOperation,
    editTank,
    editArea} from '../state/ducks/tanks';

import {api, getEmptyTank} from '../constants/tanks_constants';
import { httpClient } from './httpClient';
import { dispatch } from '../state/store';
import log from './logger/log';



const getTanksAsync = async (filter) => {
    const url = api.GET_TANKS_LIST_API;
    let postData = {
        pageNumber: filter.pagesFilter.currentPage,
        modelFilter: {},
        sortFilter: {}
    }
    try {
        const data = await httpClient.post(url, postData);
        let tanks = {
            items: data.items,
            filter: { pagesFilter: { currentPage: data.currentPage, pageCount: data.pagesCount, maxItemsOnPage: data.maxItemsOnPage } }
        }
        dispatch(setTanks(tanks.items, tanks.filter));
    } catch (error) {
        log.error(JSON.stringify(error));
    }
};

const getTankAsync = async (tankId) => {
    let tank = getEmptyTank();
    if (tankId === 0) {        
        return tank;
    }

    const url = api.GET_TANK_API + "?tankId=" + tankId;

    try {
        tank = await httpClient.get(url);
        return tank;
    } catch (error) {
        log.error(JSON.stringify(error));
        return tank;
    }
};

const addTankAsync = async (tank, graduationFile) => {
    const url = api.ADD_TANK_API;
    const addedTank = Object.assign({}, tank);
    try {
        if (graduationFile) {
            const data = await httpClient.uploadFile(api.UPLOAD_GRADUATIONS, graduationFile);
            log.trace(data);
            let fileId = parseInt(data);
            addedTank.graduationFileId = fileId;
        };
        tank = await httpClient.post(url, addedTank);
        dispatch(addTank(addedTank));
    } catch (error) {
        log.error(JSON.stringify(error));
        return;
    }
};

const editTankAsync = async (tank, graduationFile) => {
    const url = api.EDIT_TANK_API;
    try {
        if (graduationFile) {
            const data = await httpClient.uploadFileWithDispatch(dispatch, api.UPLOAD_GRADUATIONS, graduationFile);
            log.trace(data);
            let fileId = parseInt(data);
            tank.graduationFileId = fileId;
        };
        tank = await httpClient.post(url, tank);
        dispatch(editTank(tank));
    } catch (error) {
        log.error(JSON.stringify(error));
        return;
    }
};

const getAreasAsync = async () => {
    const url = api.GET_AREAS_API;
    try {
        const areas = await httpClient.get(url);
        dispatch(setAreas(areas));
        return areas;
    } catch (error) {
        log.error(JSON.stringify(error));
        return null;
    }
};

const addAreaAsync = async (area) => {
    const url = api.ADD_AREA_API;
    try {
        area = await httpClient.post(url, area);
        dispatch(addArea(area));
    } catch (error) {
        log.error(JSON.stringify(error));
        return;
    }
};

const editAreaAsync = async (area) => {
    const url = api.EDIT_AREA_API;
    try {
        area = await httpClient.post(url, area);
        dispatch(editArea(area));
    } catch (error) {
        log.error(JSON.stringify(error));
        return;
    }
};

const getTankOperationsAsync = async (filter) => {
    const url = api.GET_TANK_OPERATIONS_API;
    const postData = {
        pageNumber: filter.pagesFilter.currentPage,
        modelFilter: filter.modelFilter,
        sortFilter: {}
    }
    try {
        const data = await httpClient.post(url, postData);
        const tankOperations = {
            items: data.items,
            filter: {
                pagesFilter: { currentPage: data.currentPage, pageCount: data.pagesCount, maxItemsOnPage: data.maxItemsOnPage },
                modelFilter: filter.modelFilter,
                sortFilter: filter.sortFilter
            }
        }

        return tankOperations;
    } catch (error) {
        return null;
    }
};

const getTanksStateOperationsAsync = async (filter) => {
    const url = api.GET_TANKS_STATE_OPERATIONS_API;
    const postData = {
        pageNumber: filter.pagesFilter.currentPage,
        modelFilter: filter.modelFilter,
        sortFilter: {}
    }
    try {
        const data = await httpClient.post(url, postData);
        const tanksStateOperations = {
            items: data.items,
            filter: {
                pagesFilter: { currentPage: data.currentPage, pageCount: data.pagesCount, maxItemsOnPage: data.maxItemsOnPage },
                modelFilter: filter.modelFilter,
                sortFilter: filter.sortFilter
            }
        }
        dispatch(setTanksStateOperations(tanksStateOperations.items, tanksStateOperations.filter));
        return tanksStateOperations;
    } catch (error) {
        log.error(JSON.stringify(error));
        return null;
    }
};

const getTanksOperationsAsync = async (filter) => {
    const url = api.GET_TANK_OPERATIONS_API;
    const postData = {
        pageNumber: filter.pagesFilter.currentPage,
        modelFilter: filter.modelFilter,
        sortFilter: {}
    }
    try {
        const data = await httpClient.post(url, postData);
        const tankOperations = {
            items: data.items,
            filter: {
                pagesFilter: { currentPage: data.currentPage, pageCount: data.pagesCount, maxItemsOnPage: data.maxItemsOnPage },
                modelFilter: filter.modelFilter,
                sortFilter: filter.sortFilter
            }
        }
        dispatch(setTanksOperations(tankOperations.items, tankOperations.filter));
        return tankOperations;
    } catch (error) {
        log.error(JSON.stringify(error));
        return null;
    }
};

const addTankOperationAsync = async (tankOperation, ownProps) => {
    const url = api.ADD_TANK_OPERATIONS_API;
    //const getTankurl = api.GET_TANK_API + "?tankId=" + tankOperation.tankId;
    try {
        tankOperation = await httpClient.post(url, tankOperation);
        // dispatch(addTankOperation())
        //const tank = await request_helper.callWithDispatch(dispatch, "GET", getTankurl);
        //dispatch({ type: actions.EDIT_TANK, tank });
        // ownProps.history.goBack();
    } catch (error) {
        log.error(JSON.stringify(error));
        return;
    }
};

const getOperationsReportAsync = async (filter) => {
    const url = api.GET_TANK_OPERATIONS_REPORT_API;

    const postData = {
        pageNumber: filter.pagesFilter.currentPage,
        modelFilter: filter.modelFilter,
        sortFilter: {}
    }

    try {
        const response = await httpClient.getReport("POST", url, postData);
        return response;
    }
    catch (error) {
        log.error(JSON.stringify(error));
    }
};

const getTankStateOperationsReportAsync = async (filter) => {
    const url = api.GET_TANKS_STATE_OPERATIONS_REPORT_API;

    const postData = {
        pageNumber: filter.pagesFilter.currentPage,
        modelFilter: filter.modelFilter,
        sortFilter: {}
    }
    
    try {
        const response = await httpClient.getReport("POST", url, postData);
        return response;
    }
    catch (error) {
        log.error(JSON.stringify(error));
    }
};

const getGraduationsFileAsync = async (fileId) =>{
    const url = `${api.DOWNLOAD_GRADUATIONS}?fileId=${fileId}`;

    try {
        const response = await httpClient.downloadFile(url);
        return response;
    }
    catch (error) {
        log.error(JSON.stringify(error));
    }
};

const getTanksSilentAsync = async () => {
    const url = api.GET_TANKS_ALL_LIST_API;
    try {
        const data = await httpClient.get(url);
        return data;
    } catch (error) {
        log.error(JSON.stringify(error));
        return [];
    }
};


const tankService = {
    getTanksAsync,
    getTankAsync,
    getAreasAsync,
    getGraduationsFileAsync,
    getOperationsReportAsync,
    getTankOperationsAsync,
    getTankStateOperationsReportAsync,
    getTanksStateOperationsAsync,
    addTankAsync,
    addAreaAsync,
    addTankOperationAsync,
    editAreaAsync,
    editTankAsync,
    getTanksSilentAsync,
    getTanksOperationsAsync
}

export default tankService;